import { Link } from "@tanstack/react-router";
import { SITE, whatsappUrl } from "@/lib/site";
import logoAsset from "@/assets/svg-logo.png.asset.json";
import { LocationsFooterMenu } from "@/components/LocationsFooterMenu";
import { AUTOMACAO_LIST } from "@/lib/automacao-pages";

export function Footer() {
  return (
    <footer className="mt-24 border-t border-border bg-[color:var(--color-sidebar)]">
      <div className="container-svg grid gap-10 py-14 md:grid-cols-5">
        <div className="md:col-span-2">
          <img
            src={logoAsset.url}
            alt="SVG Multimídia"
            width={180}
            height={54}
            loading="lazy"
            className="h-12 w-auto"
          />
          <p className="mt-4 max-w-md text-sm text-muted-foreground">
            Automação de atendimento com IA, CRM para WhatsApp e consultoria comercial: estruturamos o atendimento e as vendas da sua empresa do primeiro contato ao fechamento.
          </p>

          <a href={whatsappUrl()} target="_blank" rel="noopener" className="btn-primary mt-6">Falar no WhatsApp</a>
          <div className="mt-6 max-w-md">
            <LocationsFooterMenu />
          </div>
          <div className="mt-6 flex flex-wrap gap-3">
            <a
              href={SITE.social.instagram}
              target="_blank"
              rel="noopener"
              aria-label="Instagram da SVG Multimídia"
              className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-ink/10 bg-ink/[0.04] text-muted-foreground transition hover:-translate-y-0.5 hover:border-primary hover:text-primary"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
                <rect x="3" y="3" width="18" height="18" rx="5" />
                <circle cx="12" cy="12" r="4" />
                <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
              </svg>
            </a>
            <a
              href={SITE.social.youtube}
              target="_blank"
              rel="noopener"
              aria-label="YouTube de Mário Jorge"
              className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-ink/10 bg-ink/[0.04] text-muted-foreground transition hover:-translate-y-0.5 hover:border-primary hover:text-primary"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
                <path d="M23 7.2a3 3 0 0 0-2.1-2.1C19 4.6 12 4.6 12 4.6s-7 0-8.9.5A3 3 0 0 0 1 7.2 31 31 0 0 0 .5 12 31 31 0 0 0 1 16.8a3 3 0 0 0 2.1 2.1c1.9.5 8.9.5 8.9.5s7 0 8.9-.5a3 3 0 0 0 2.1-2.1 31 31 0 0 0 .5-4.8 31 31 0 0 0-.5-4.8ZM9.8 15.4V8.6l5.8 3.4-5.8 3.4Z" />
              </svg>
            </a>
            <a
              href={SITE.social.youtubeSvg}
              target="_blank"
              rel="noopener"
              aria-label="Canal da SVG Multimídia no YouTube"
              className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-ink/10 bg-ink/[0.04] text-muted-foreground transition hover:-translate-y-0.5 hover:border-primary hover:text-primary"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
                <path d="M23 7.2a3 3 0 0 0-2.1-2.1C19 4.6 12 4.6 12 4.6s-7 0-8.9.5A3 3 0 0 0 1 7.2 31 31 0 0 0 .5 12 31 31 0 0 0 1 16.8a3 3 0 0 0 2.1 2.1c1.9.5 8.9.5 8.9.5s7 0 8.9-.5a3 3 0 0 0 2.1-2.1 31 31 0 0 0 .5-4.8 31 31 0 0 0-.5-4.8ZM9.8 15.4V8.6l5.8 3.4-5.8 3.4Z" />
              </svg>
            </a>
            <a
              href={SITE.social.facebook}
              target="_blank"
              rel="noopener"
              aria-label="Facebook da SVG Multimídia"
              className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-ink/10 bg-ink/[0.04] text-muted-foreground transition hover:-translate-y-0.5 hover:border-primary hover:text-primary"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
                <path d="M22 12a10 10 0 1 0-11.6 9.9v-7H7.9V12h2.5V9.8c0-2.5 1.5-3.9 3.8-3.9 1.1 0 2.2.2 2.2.2v2.5h-1.3c-1.2 0-1.6.8-1.6 1.6V12h2.8l-.4 2.9h-2.3v7A10 10 0 0 0 22 12Z" />
              </svg>
            </a>
          </div>
        </div>
        <div>
          <h3 className="text-sm font-semibold">Automação e CRM</h3>
          <ul className="mt-4 space-y-2 text-sm text-muted-foreground">
            <li><Link to="/crm-yt" className="hover:text-foreground">CRM SVG com IA</Link></li>
            <li><Link to="/crm-para-whatsapp" className="hover:text-foreground">CRM para WhatsApp</Link></li>
            <li><Link to="/automacao-comercial" className="hover:text-foreground">Automação comercial</Link></li>
            {AUTOMACAO_LIST.map((p) => (
              <li key={p.slug}><Link to={"/" + p.slug} className="hover:text-foreground">{p.navLabel}</Link></li>
            ))}
            <li><Link to="/venda-no-whatsapp-metodo-conversa" className="hover:text-foreground">Método CONVERSA</Link></li>
            <li><Link to="/suporte-crm" className="hover:text-foreground">Suporte e Treinamento</Link></li>
          </ul>
        </div>
        <div>
          <h3 className="text-sm font-semibold">SEO e presença digital</h3>
          <ul className="mt-4 space-y-2 text-sm text-muted-foreground">
            <li><Link to="/otimizacao-ficha-google" className="hover:text-foreground">Ficha do Google</Link></li>
            <li><Link to="/criacao-de-sites" className="hover:text-foreground">Criação de Sites</Link></li>
            <li><Link to="/seo-local" className="hover:text-foreground">SEO Local</Link></li>
            <li><Link to="/seo-nacional" className="hover:text-foreground">SEO Nacional</Link></li>
            <li><Link to="/plano-autoridade-local" className="hover:text-foreground">Plano Autoridade Local</Link></li>
            <li><Link to="/metodo-svg" className="hover:text-foreground">Método SVG</Link></li>
          </ul>
        </div>
        <div>
          <h3 className="text-sm font-semibold">Empresa</h3>
          <ul className="mt-4 space-y-2 text-sm text-muted-foreground">
            <li><Link to="/sobre" className="hover:text-foreground">Sobre</Link></li>
            <li><Link to="/equipe" className="hover:text-foreground">Equipe</Link></li>
            <li><Link to="/academia" className="hover:text-foreground">Academia SVG</Link></li>
            <li><Link to="/blog" className="hover:text-foreground">Blog</Link></li>
            <li><Link to="/contato" className="hover:text-foreground">Contato</Link></li>
            <li><a href={`mailto:${SITE.email}`} className="hover:text-foreground">{SITE.email}</a></li>
            <li><a href="https://pixel.agendasistemacrm.com.br/r/qxgushz" target="_blank" rel="noopener" className="hover:text-foreground">{SITE.phoneDisplay}</a></li>
            <li>
              <Link
                to="/auth"
                className="inline-flex items-center gap-2 rounded-lg border border-border bg-secondary/40 px-3 py-1.5 text-xs font-medium text-foreground hover:border-primary hover:text-primary"
              >
                Acesso ao Blog
              </Link>
            </li>
          </ul>
        </div>

      </div>
      <div className="border-t border-border">
        <div className="container-svg flex flex-col items-start justify-between gap-2 py-6 text-xs text-muted-foreground md:flex-row md:items-center">
          <p>© {new Date().getFullYear()} {SITE.name}. Todos os direitos reservados. · CNPJ 57.063.169/0001-08</p>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <Link to="/termos-de-uso" className="hover:text-foreground">Termos de Uso</Link>
            <Link to="/politica-de-privacidade" className="hover:text-foreground">Política de Privacidade</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}